import Chartist from 'chartist';
import tooltip from '../../../services/chartist-tooltip';
import { DAILY, HOURLY, MONTHLY } from '../models/resolution';
import { SPLIT_DATE, SPLIT_DATE_STR } from '../models/period';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

require('chartist-plugin-legend');

export function labelInterpolation(value, resolution) {
  switch (resolution) {
    case HOURLY:
      return dayjs.utc(value).format('HH:mm');
    case MONTHLY:
      return `${dayjs.utc(value).format('MMM')} ${dayjs.utc(value).year()}`;
    default:
      return dayjs.utc(value).format('MMM D');
  }
}

function getDivisor(numberOfpoints, resolution) {
  var divisor = 0;
  if (resolution === HOURLY) {
    divisor = numberOfpoints - 1;
  } else {
    divisor = numberOfpoints < 10 ? numberOfpoints : 10;
  }
  return divisor;
}

function getTooltipTemplate(multiGraph, className, multiGraphClassNames = [], date) {
  let template =
    multiGraph && date >= SPLIT_DATE
      ? `<div>
{{meta}}</br>
<div>
    <div class="tooltip-square {{typea}}"></div>
    <span class="tooltip-text">{{typea}}: {{ya}}</span>
</div>
<div>
    <div class="tooltip-square {{typeb}}"></div>
    <span class="tooltip-text">{{typeb}}: {{yb}}</span>
</div>
<div>
<span class="tooltip-text">Total: {{sum}}</span>

</div>
</div>`
      : `<div>
{{meta}}</br>
<div>
  <div class="${className}"></div>
  <span class="tooltip-text">{{type}}: {{y}}</span>
</div>
</div>`;
  return template;
}

function pluginVerticalLine(value, style, options) {
  let styleString = Object.keys(style)
    .map(function (prop) {
      return prop + ': ' + style[prop];
    })
    .join(';');

  return function pluginVerticalLine(chart) {
    let tooltip = document.createElement('div');
    tooltip.style.visibility = 'hidden';
    tooltip.style.opacity = '0';
    tooltip.className = 'ct-tooltip-a';
    tooltip.style.transition = 'visibility 0s 0.5s, opacity 0.5s linear';
    chart.container.style.position = 'relative';
    chart.container.appendChild(tooltip);
    chart.on('created', function (data) {
      const mouseenterListener = function () {
        let xPos = options.labelOffset.x + data.chartRect.x1 + data.axisX.projectValue(value) - 8;
        tooltip.style.left = xPos + 'px';
        tooltip.style.position = 'relative';
        tooltip.style.top = '-80px';
        tooltip.style.display = 'inline-block';
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '1';
        tooltip.style.transition = 'opacity 0.5s linear';
        tooltip.style.animation = 'fadein 0.5s';
        tooltip.innerHTML =
          '<div style="display: grid;"><span>Starting April 1st, 2019 the data</span><span>calculation and reporting has</span><span>been upgraded</span></div>';
      };
      const mouseleaveListener = function () {
        tooltip.style.visibility = 'hidden';
        tooltip.style.opacity = '0';
        tooltip.style.transition = 'visibility 0s 0.5s, opacity 0.5s linear';
      };
      let linePos = data.chartRect.x1 + data.axisX.projectValue(value);
      data.svg.elem('line', {
        x1: linePos,
        x2: linePos,
        y1: data.chartRect.y1,
        y2: data.chartRect.y2,
        style: styleString
      });
      let circle = data.svg.elem(
        'circle',
        {
          cx: [linePos],
          cy: [data.chartRect.y2],
          r: [8],
          'ct:value': 20,
          style: 'fill:#be1818; cursor:pointer'
        },
        'chart-point'
      );
      let text = data.svg.elem('text', {
        x: [linePos],
        y: [data.chartRect.y2 + 4],
        'font-size': '12px',
        'text-anchor': 'middle',
        fill: 'white',
        'font-weight': 800,
        cursor: 'pointer'
      });
      text._node.innerHTML = '!';
      circle._node.innerHTML = '!';
      circle._node.addEventListener('mouseenter', mouseenterListener);
      circle._node.addEventListener('mouseleave', mouseleaveListener);
      text._node.addEventListener('mouseenter', mouseenterListener);
      text._node.addEventListener('mouseleave', mouseleaveListener);
    });
  };
}

function getDefaultOptions(
  type,
  numberOfpoints,
  resolution,
  legendNames,
  classNames,
  multiGraph = false
) {
  var className = 'tooltip-square';
  numberOfpoints = numberOfpoints || 10;
  switch (type) {
    case 'likes':
      className += ' likes';
      break;
    case 'page_views':
      className += ' pageViews';
      break;
    case 'comments':
      className += ' comments';
      break;
    case 'registrations':
      className += ' registrations';
      break;
  }
  var options = {
    low: 0,
    showArea: true,
    bezierCurve: false,
    lineSmooth: Chartist.Interpolation.simple({ divisor: 2 }),
    fullWidth: true,
    axisY: {
      onlyInteger: true
    },
    axisX: {
      type: Chartist.FixedScaleAxis,
      divisor: getDivisor(numberOfpoints, resolution),
      labelInterpolationFnc: function (value, index, label) {
        switch (resolution) {
          case DAILY:
            var customLabel = dayjs(value).utc().format('MMM D');
            var isExist = false;
            for (let i = index - 1; i > 0; i--) {
              if (customLabel === dayjs(label[i]).utc().format('MMM D')) {
                isExist = true;
              }
            }

            if (!isExist) {
              return labelInterpolation(value, resolution);
            }
            break;
          case HOURLY:
          case MONTHLY:
            return labelInterpolation(value, resolution);
        }
      }
    },
    plugins: [
      tooltip({
        hover: 'point',
        labelOffset: {
          x: -90,
          y: multiGraph ? -120 : -80
        },
        getTemplate: function (date = new Date().getTime()) {
          return getTooltipTemplate(multiGraph, className, classNames, date);
        }
        // template: `<div>
        //             {{meta}}</br>
        //             <div>
        //                 <div class="${className}"></div>
        //                 <span class="tooltip-text">{{type}}: {{y}}</span>
        //             </div>
        //         </div>`,
      }),
      pluginVerticalLine(
        new Date(SPLIT_DATE_STR),
        {
          stroke: '#be1818',
          'stroke-width': 2
        },
        {
          labelOffset: {
            x: -90,
            y: multiGraph ? -120 : -80
          }
        }
      ),
      Chartist.plugins.legend({
        legendNames: legendNames,
        classNames: classNames,
        clickable: false,
        position: 'bottom'
      })
    ]
  };
  return options;
}

export default getDefaultOptions;
